import { Navigate } from "react-router-dom";
import { ROUTES } from "@/app/constants";
import { useAuthStore } from "@/stores/authStore";
import { pickHomeForRole } from "@/app/router/roleHome";

/**
 * Root path (`/`) redirect. Signed-out → /event-mode (the public landing
 * page). Pending Approval → the dedicated pending-approval screen.
 * Otherwise, role's own home (admin shell for staff, client portal for
 * clients).
 *
 * Signed-out used to go straight to /login (changed 2026-07-17) — every
 * anonymous visitor hit a bare login form with no context on what the
 * product even is. /event-mode is the actual marketing/landing page and
 * itself carries Login/Register buttons, so this is a strict improvement
 * with no dead end: a visitor can still reach /login in one click.
 *
 * The previous hard-coded `<Navigate to="/dashboard">` sent every user,
 * regardless of role, into the admin shell — that's how the CLIENT
 * user showed up on `/dashboard` in the first place.
 */
export function RoleHomeRedirect() {
  const { user, loading } = useAuthStore();

  if (loading) return <p>Loading…</p>;
  if (!user) return <Navigate to={ROUTES.event} replace />;
  if (user.status === "Pending Approval") {
    return <Navigate to={ROUTES.pendingApproval} replace />;
  }
  return <Navigate to={pickHomeForRole(user.role)} replace />;
}
